<div class="card">
  <div class="card-header">
    <div class="row align-items-center flex-nowrap">
      <div class="col">
        <div class="row g-2 flex-nowrap align-items-center">
          <div class="col-auto">
            <div class="card-icon">
              <i class="bx bxs-calendar-event"></i>
            </div>
          </div>
          <div class="col">
            <ng-container *ngIf="role === 'COMMUNITY_RESIDENT'; else title">
              <h4 class="m-0">My Calendar</h4>
            </ng-container>
            <ng-template #title>
              <h4 class="m-0" *ngIf="resident$ | async as _resident">
                {{ _resident.firstName }}´s Calendar
              </h4>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col text-end lh-1">
        <a [routerLink]="['calendar']" class="text-icon float-end">
          All community events
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="card-body">
    <ng-container *ngIf="(groups$ | async)?.length; else empty">
      <ngx-simplebar class="h-100" #calendar>
        <ng-container *ngFor="let item of groups$ | async; let i = index">
          <h6 class="text-dark fw-bolder">
            {{ item.category }}
          </h6>

          <ng-container *ngFor="let event of item.events; let j = index">
            <div class="card border shadow-none">
              <div class="card-body">
                <app-event-card
                  [event]="event"
                  colImage="col-md-5"
                  [type]="'USER'"
                ></app-event-card>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ngx-simplebar>
    </ng-container>
  </div>
</div>

<ng-template #empty>
  <div class="row">
    <div class="col-12">
      <div role="alert" class="alert alert-info d-flex">
        <i class="bx bxs-info-circle me-2 mt-1"></i>
        <div>
          <h6 class="m-0 fw-bolder">No Events</h6>
          <p class="m-0">There are no events today.</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
